"use strict";

var _regeneratorRuntime = require("/codebuild/output/src3315055034/src/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/codebuild/output/src3315055034/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/codebuild/output/src3315055034/src/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src3315055034/src/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractTokenizer = void 0;

var peek_readable_1 = require("peek-readable");
/**
 * Core tokenizer
 */


var AbstractTokenizer = /*#__PURE__*/function () {
  function AbstractTokenizer(fileInfo) {
    _classCallCheck(this, AbstractTokenizer);

    /**
     * Tokenizer-stream position
     */
    this.position = 0;
    this.numBuffer = new Uint8Array(8);
    this.fileInfo = fileInfo ? fileInfo : {};
  }
  /**
   * Read a token from the tokenizer-stream
   * @param token - The token to read
   * @param position - If provided, the desired position in the tokenizer-stream
   * @returns Promise with token data
   */


  _createClass(AbstractTokenizer, [{
    key: "readToken",
    value: function () {
      var _readToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token) {
        var position,
            uint8Array,
            len,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                position = _args.length > 1 && _args[1] !== undefined ? _args[1] : this.position;
                uint8Array = Buffer.alloc(token.len);
                _context.next = 4;
                return this.readBuffer(uint8Array, {
                  position: position
                });

              case 4:
                len = _context.sent;

                if (!(len < token.len)) {
                  _context.next = 7;
                  break;
                }

                throw new peek_readable_1.EndOfStreamError();

              case 7:
                return _context.abrupt("return", token.get(uint8Array, 0));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function readToken(_x) {
        return _readToken.apply(this, arguments);
      }

      return readToken;
    }()
    /**
     * Peek a token from the tokenizer-stream.
     * @param token - Token to peek from the tokenizer-stream.
     * @param position - Offset where to begin reading within the file. If position is null, data will be read from the current file position.
     * @returns Promise with token data
     */

  }, {
    key: "peekToken",
    value: function () {
      var _peekToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(token) {
        var position,
            uint8Array,
            len,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                position = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : this.position;
                uint8Array = Buffer.alloc(token.len);
                _context2.next = 4;
                return this.peekBuffer(uint8Array, {
                  position: position
                });

              case 4:
                len = _context2.sent;

                if (!(len < token.len)) {
                  _context2.next = 7;
                  break;
                }

                throw new peek_readable_1.EndOfStreamError();

              case 7:
                return _context2.abrupt("return", token.get(uint8Array, 0));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function peekToken(_x2) {
        return _peekToken.apply(this, arguments);
      }

      return peekToken;
    }()
    /**
     * Read a numeric token from the stream
     * @param token - Numeric token
     * @returns Promise with number
     */

  }, {
    key: "readNumber",
    value: function () {
      var _readNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(token) {
        var len;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.readBuffer(this.numBuffer, {
                  length: token.len
                });

              case 2:
                len = _context3.sent;

                if (!(len < token.len)) {
                  _context3.next = 5;
                  break;
                }

                throw new peek_readable_1.EndOfStreamError();

              case 5:
                return _context3.abrupt("return", token.get(this.numBuffer, 0));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function readNumber(_x3) {
        return _readNumber.apply(this, arguments);
      }

      return readNumber;
    }()
    /**
     * Read a numeric token from the stream
     * @param token - Numeric token
     * @returns Promise with number
     */

  }, {
    key: "peekNumber",
    value: function () {
      var _peekNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(token) {
        var len;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.peekBuffer(this.numBuffer, {
                  length: token.len
                });

              case 2:
                len = _context4.sent;

                if (!(len < token.len)) {
                  _context4.next = 5;
                  break;
                }

                throw new peek_readable_1.EndOfStreamError();

              case 5:
                return _context4.abrupt("return", token.get(this.numBuffer, 0));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function peekNumber(_x4) {
        return _peekNumber.apply(this, arguments);
      }

      return peekNumber;
    }()
    /**
     *  Ignore number of bytes, advances the pointer in under tokenizer-stream.
     * @param length - Number of bytes to ignore
     * @return resolves the number of bytes ignored, equals length if this available, otherwise the number of bytes available
     */

  }, {
    key: "ignore",
    value: function () {
      var _ignore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(length) {
        var bytesLeft;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.fileInfo.size !== undefined)) {
                  _context5.next = 5;
                  break;
                }

                bytesLeft = this.fileInfo.size - this.position;

                if (!(length > bytesLeft)) {
                  _context5.next = 5;
                  break;
                }

                this.position += bytesLeft;
                return _context5.abrupt("return", bytesLeft);

              case 5:
                this.position += length;
                return _context5.abrupt("return", length);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function ignore(_x5) {
        return _ignore.apply(this, arguments);
      }

      return ignore;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "normalizeOptions",
    value: function normalizeOptions(uint8Array, options) {
      if (options && options.position !== undefined && options.position < this.position) {
        throw new Error('`options.position` must be equal or greater than `tokenizer.position`');
      }

      if (options) {
        return {
          mayBeLess: options.mayBeLess === true,
          offset: options.offset ? options.offset : 0,
          length: options.length ? options.length : uint8Array.length - (options.offset ? options.offset : 0),
          position: options.position ? options.position : this.position
        };
      }

      return {
        mayBeLess: false,
        offset: 0,
        length: uint8Array.length,
        position: this.position
      };
    }
  }]);

  return AbstractTokenizer;
}();

exports.AbstractTokenizer = AbstractTokenizer;